import { observer } from 'mobx-react-lite';
import { useEsriMapStore } from '../../../hooks/use-esri-map-store';
import {
    getDispatchAreaById,
    getStationAdminArea1DisplayValue,
    getStationLocalityDisplayValue,
    getStationStreetAddressDisplayValue,
} from '../helpers';
import { StationOverview } from './station-overview';
import { AgencyTypeGlobal, agencyTypeIdToDisplay } from '../../../../common/global-attributes';
import { LocationAddressAndGpsSection } from '../location-address-and-gps-section';
import { useBootstrapState } from '../../../../bootstrap/bootstrap-provider';
import { PanelWrapper } from '../panel-wrapper';
import { useApplicationType } from '../../../../common/hooks/use-application-type';

export const StationPanel = observer(function StationPanel(): React.ReactElement {
    const mapStore = useEsriMapStore();
    const { manageDispatchAreasView } = useBootstrapState();

    const selectedStation = mapStore.selectedStation;
    const allDispatchAreaObjects = manageDispatchAreasView?.allDispatchAreaObjects;

    const { isFirstResponder } = useApplicationType();
    const size = isFirstResponder ? 'lg' : 'md';

    const { station, location } = selectedStation || {};
    const { name, agencyTypeGlobalAttrId, dispatchAreaId } = station || {};
    const {
        latitude,
        longitude,
        areCoordinatesVerified,
        streetAddress,
        locality,
        adminArea1,
        postalCode,
        crossStreet1,
        crossStreet2,
    } = location || {};

    const streetAddressDisplay = getStationStreetAddressDisplayValue(
        streetAddress,
        locality,
        adminArea1,
        postalCode
    );
    const localityDisplay = getStationLocalityDisplayValue(locality, adminArea1, postalCode);
    const adminArea1Display = getStationAdminArea1DisplayValue(adminArea1, postalCode);
    const postalCodeDisplay = postalCode || '';

    const stationFullAddress = `${streetAddressDisplay}${localityDisplay}${adminArea1Display}${postalCodeDisplay}`;

    const stationTypeDisplay = agencyTypeGlobalAttrId
        ? agencyTypeIdToDisplay[agencyTypeGlobalAttrId as AgencyTypeGlobal].capitalize
        : 'Fire';

    const dispatchArea = getDispatchAreaById(dispatchAreaId!, allDispatchAreaObjects);

    return (
        <PanelWrapper testId="MAP_STATION_PANEL">
            <StationOverview
                stationNumber={name!}
                agencyTypeGlobalAttrId={agencyTypeGlobalAttrId}
                size={size}
            />
            {location && (
                <LocationAddressAndGpsSection
                    geoLocationLatitude={latitude}
                    geoLocationLongitude={longitude}
                    areGeoLocationCoordinatesVerified={areCoordinatesVerified}
                    stationCrossStreet1={crossStreet1}
                    stationCrossStreet2={crossStreet2}
                    stationDispatchArea={dispatchArea}
                    stationTypeDisplay={stationTypeDisplay}
                    stationFullAddress={stationFullAddress}
                    size={size}
                />
            )}
        </PanelWrapper>
    );
});
